export interface PostRequestPayload {
  coachId: string;
  coachStarterProfileId?: string;
  coachName?: string;
  message: string;
  startOfDay: string;
  endOfDay: string;
}

export interface PostResponsePayload {
  success: boolean;
  bookingRequestId: string;
  message?: string;
}

export const CONTACT_COACH_API = 'v1/coaches/contact';
